class Adtraction {
    constructor() {}

    addAdtractionSales(orderId, emailHash) {

        if(!window.ADT || !window.ADT.Tag || typeof window.ADT.Tag.doEvent !== 'function') {
            return;
        }

        window.ADT.Tag.ti = orderId;
        window.ADT.Tag.xd = emailHash;
        try {
            window.ADT.Tag.doEvent();
            console.log('Adtraction tracking executed for Order ID:', orderId);
        }
        catch (e) {
            console.error('Error executing Adtraction tracking:', e);
        }
    }
}

// Export a singleton instance
export const adtraction = new Adtraction();
